import { Component, Input, OnInit } from '@angular/core';
import { AppService } from 'src/@core/services/app.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-view-job-details',
  templateUrl: './view-job-details.component.html',
  styleUrls: ['./view-job-details.component.scss']
})
export class ViewJobDetailsComponent implements OnInit {
  @Input() data: any = null;
  @Input() jobType: any = null;
  @Input() hidePadding?: any;
  imageUrl = environment.image_url;
  roles = roles;
  entityTypes = entityTypes;
  showTermsSection: boolean = true;
  profile = this.appService.getCurrentAccount();
  customFieldsArray: any[] = [];

  constructor(
    private appService: AppService
  ) { }

  ngOnInit() {
    console.log("this.data=", this.data, this.jobType)
    if (this.data.selectedClientType == 'Self' || this.profile.entity.entityType === 'ENTERPRISE'
      || (this.data && this.data.createdByEntity && this.data.createdByEntity.id != this.profile.entity.id)) {
      this.showTermsSection = false;
    }
    this.setAgenciesName();
  }

  ngAfterViewInit() {
    console.log("#####################")
  }

  setAgenciesName() {
    if (this.data && this.data.assignedEntities && this.data.assignedEntities.length) {
      this.data.assignedEntitiesName = [];
      this.data.assignedEntities.forEach(element => {
        this.data.assignedEntitiesName.push(element.name);
      })
    }
  }

  getTotalQuantity() {
    let quantity = 0;
    if (this.data && this.data.rateCards && this.data.rateCards.length) {
      this.data.rateCards.forEach(element => {
        quantity = quantity + element.quantity;
      });
    }
    return quantity;
  }

  getTotalAmount() {
    let amount = 0;
    if (this.data && this.data.rateCards && this.data.rateCards.length) {
      this.data.rateCards.forEach(element => {
        amount = amount + (element.rate * element.quantity);
      });
    }
    return amount;
  }

  getTotalBillingAmount() {
    let amount = 0;
    if (this.data && this.data.rateCards && this.data.rateCards.length) {
      this.data.rateCards.forEach(element => {
        amount = amount + (element.rate * element.quantity);
      });
    }
    return amount;
  }

  downloadAttachment(attachmentName: string): void {
    // Create an anchor element and trigger a click to download the file
    const link = document.createElement('a');
    link.href = `${this.imageUrl}${attachmentName}`;
    link.target = '_blank';
    link.download = attachmentName;
    link.click();
  }


  // get Total Billing
  getTotalBilling() {
    let totalBilling = 0;
    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.data && this.data.rateCards && this.data.rateCards.length) {
        this.data.rateCards.forEach(element => {
          totalBilling = totalBilling + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.data.variableJobRateCards && this.data.variableJobRateCards.length) {
        this.data.variableJobRateCards.forEach(element => {
          totalBilling = totalBilling + (element.rate * element.quantity);
        });
      }
    }

    return totalBilling;
  }

  // get Total Billing's GST
  getTotalBillingGST() {
    let totalBillingGST = 0;
    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.data && this.data.rateCards && this.data.rateCards.length) {
        this.data.rateCards.forEach(element => {
          totalBillingGST = totalBillingGST + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.data.variableJobRateCards && this.data.variableJobRateCards.length) {
        this.data.variableJobRateCards.forEach(element => {
          totalBillingGST = totalBillingGST + (element.rate * element.quantity);
        });
      }
    }
    return totalBillingGST * 0.18;
  }

  // get Total Billing With GST
  getTotalBillingWithGST() {
    let totalBillingWithGST = 0;

    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.data && this.data.rateCards && this.data.rateCards.length) {
        this.data.rateCards.forEach(element => {
          totalBillingWithGST = totalBillingWithGST + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.data.variableJobRateCards && this.data.variableJobRateCards.length) {
        this.data.variableJobRateCards.forEach(element => {
          totalBillingWithGST = totalBillingWithGST + (element.rate * element.quantity);
        });
      }
    }
    return totalBillingWithGST * 1.18;
  }

  // review page toggle expand
  toggleExpandValue(index: number, forWhat?: string) {
    if (forWhat == 'FIXED') {
      if (this.data.rateCards && this.data.rateCards.length) {
        this.data.rateCards.forEach((rateCard: any, idx) => {
          if (index == idx) {
            rateCard.expanded = !rateCard.expanded;
          }
        });
      }
    }

    if (forWhat == 'VARIABLE') {
      if (this.data.variableJobRateCards && this.data.variableJobRateCards.length) {
        this.data.variableJobRateCards.forEach((rateCard: any, idx) => {
          if (index == idx) {
            rateCard.expanded = !rateCard.expanded;
          }
        });
      }
    }
  }

  preventToggle(event: Event) {
    event.stopPropagation();
  }
}